import apiCarga from "@/services/vex/apiCarga";
import blobToBase64 from "@/utils/blobToBase64";
import axios from "axios";

export const getPhotosTemplate = async (enterpriseId, quizId) => {
    try {
        const uri = `/empresa/${enterpriseId}/questionario/${quizId}/imagens`;
        const response = await apiCarga.get(uri);

        let OK = response.data.status == "OK";

        if (OK)
            return response.data.data ?? null;
        else
            throw new Error(response.data.message);
    } catch (err) {
        console.erro(err);
        throw err;
    }
};

export const getPhotoBase64 = async (url) => {
    const response = await axios.get(url, {responseType: "blob"});
    if(response.headers["content-type"]) {
        if(!response.headers["content-type"]?.startsWith("image/")){
            throw new Error("A URL informada não é de uma imagem");
        }
    }
    const base64 = (await blobToBase64(response.data));
    return base64;
};
